import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "doc-sort-btn" }

import { emitter } from '@/services/mitt'


export default /*@__PURE__*/_defineComponent({
  __name: 'DocsSortButton.mobile',
  setup(__props) {

function show(): void {
  emitter.emit('openSortPopup')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      class: "doc-sort-btn__link filter-sort",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (show()))
    }, [...(_cache[1] || (_cache[1] = [
      _createElementVNode("span", { class: "doc-sort-btn__icon iconfont isort" }, null, -1)
    ]))])
  ]))
}
}

})